//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbTextfield from '@/elements/forms/rb-textfield.vue'

import { coordinatesValidation } from '@/scripts/libs/store-locator'
import { minLength, required } from 'vuelidate/lib/validators'
import { getDeviceCoordinates } from '@/scripts/libs/geolocation'
import { getBingPlacesAutocomplete, getBingAddressFromCoordinates } from '@/scripts/libs/bing-maps'
import wcs from '@/scripts/libs/wcs'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'

const { locale } = wcs.getStoreConfig()
const countryCode = WcsLocales.getCountryCode(locale)

export default {
  name: 'rb-bing-autocomplete',
  components: {
    RbTextfield,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    canPromptForGeolocation: {
      type: Boolean,
      default: false,
    },
    initialLocation: {
      type: String,
      default: '',
    },
    initialCoordinates: {
      type: Object,
      default: () => {
        return {
          latitude: '',
          longitude: '',
        }
      },
    },
    iconClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      autocomplete: undefined,
      location: '',
      latitude: '',
      longitude: '',
      inputContainerId: 'locationContainer',
    }
  },
  validations: {
    location: {
      required,
      minLenght: minLength(1),
      coordinatesValidation,
    },
  },
  mounted() {
    this.initAutocomplete()

    if (this.initialLocation) {
      this.location = this.initialLocation
    }
    if (this.initialCoordinates) {
      this.latitude = this.initialCoordinates.latitude
      this.longitude = this.initialCoordinates.longitude
    }

    if (this.canPromptForGeolocation) {
      getDeviceCoordinates(this.onGeolocationConfirm)
    }
  },
  methods: {
    onGeolocationConfirm(data) {
      const {
        coords: { latitude, longitude },
      } = data
      this.latitude = latitude
      this.longitude = longitude

      getBingAddressFromCoordinates(latitude, longitude, (answer) => {
        this.location = answer.address.formattedAddress
      })
    },
    initAutocomplete() {
      const autocompleteOptions = {
        countryCode,
      }

      this.autocomplete = getBingPlacesAutocomplete(
        autocompleteOptions,
        `#${this.id}`,
        `#${this.inputContainerId}`,
        (result) => {
          const { latitude, longitude } = result?.location
          this.location = result?.address?.formattedAddress
          this.latitude = latitude.toString()
          this.longitude = longitude.toString()

          const mapPlace = {
            latitude: this.latitude,
            longitude: this.longitude,
            requestAddress: this.location,
          }
          this.$emit('placeChanged', mapPlace)
        }
      )
    },
    getValue(e) {
      this.$v.$touch()
      this.location = e.target.getValue
      this.latitude = null
      this.longitude = null
      this.$emit('inputValue', { value: this.location, latitude: null, longitude: null })

      if (!e.target.value.length) {
        this.clearField()
      }
    },
    clearField() {
      this.location = ''
      this.$emit('inputValue', { value: this.location, latitude: null, longitude: null })
    },
    onSearchIconClick() {
      this.$emit('onSearchIconClick')
    },
  },
}
